import * as React from "react";

function SvgCart(props) {
  return <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><circle cx={21} cy={23} r={1.5} stroke="currentColor" /><circle cx={13} cy={23} r={1.5} stroke="currentColor" /><path fill="currentColor" d="M25.13 10H9.5l-.63-2H5.5v1h2.63l3 10h11.76l2.61-9h-1l-2.39 8H11.87l-2.1-7H25c0-.34.04-.68.13-1z" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/cart_730729.svg";
export { SvgCart as ReactComponent };